import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "src/store/features/auth/axiosCSRF";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";
import { getApiErrorMessage } from "src/types/api";

export interface iResetPasswordConfirmState {
  response: any | null;
  isLoading: boolean;
  message: string | null;
}

const initialState: iResetPasswordConfirmState = {
  response: null,
  isLoading: false,
  message: null,
};

export const postPasswordResetConfirm = createAsyncThunk(
  "POST_PASSWORD_RESET_CONFIRM",
  async (
    params: { sid: string; token: string; new_password: string },
    { rejectWithValue }
  ) => {
    try {
      const djangoEndpoint = getDjangoEndpoint();
      const pathParam = "/auth/password-reset/complete/";
      const response = await axiosInstance.post(
        `${djangoEndpoint}${pathParam}`,
        {
          sid: params.sid,
          token: params.token,
          new_password: params.new_password,
        },
        {
          withCredentials: true,
        }
      );
      return response.data;
    } catch (e) {
      return rejectWithValue(getApiErrorMessage(e));
    }
  }
);

export const postPasswordResetConfirmSlice = createSlice({
  name: "postPasswordResetConfirm",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postPasswordResetConfirm.pending, (state) => {
        state.isLoading = true;
        state.message = null;
      })
      .addCase(postPasswordResetConfirm.fulfilled, (state, action) => {
        state.isLoading = false;
        state.response = action.payload;
      })
      .addCase(postPasswordResetConfirm.rejected, (state, action) => {
        state.isLoading = false;
        state.message = action.payload as string;
      });
  },
});

export default postPasswordResetConfirmSlice.reducer;
